import request from '../../utils/request'
export const creatOrder = (data) => {
    return request({
        url: process.env.VUE_APP_TRADER + 'order/insurance',
        method: 'post',
        data
    })
}
export const inspectOrder = (kind,data) => {
    return request({
        url: process.env.VUE_APP_TRADER + `order/state/${kind}/${data}`,
        method: 'get',
    })
}
export const couponOrder = (data) => {
    return request({
        url: process.env.VUE_APP_TRADER + `order/coupon`,
        method: 'post',
        data
    })
}
export const priceList = (data) => {
    return request({
        url:'api/policy/insure/price/list',
        method: 'post',
        data
    })
}
export const checkEntrust = (data) => {
    return request({
        url: `/trader/order/check-entrust/${data}`,
        method: 'GET',
    })
}
// 查询签约状态
export const checkEntrustSerial = (data) => {
    return request({
        url: `/trader/order/entrust/common/${data}`,
        method: 'GET',
    })
}
export const couponReceive = (data) => {
    return request({
        url: `/trader/order/coupon-receive`,
        method: 'post',
        data
    })
}
export const underWriting = (data) => {
    return request({
        url: `/trader/order/underwriting`,
        method: 'post',
        data
    })
}
// 新的支付下单接口 
export const transactions = (data) => {
    return request({
        url: `trader/order/transactions`,
        method: 'post',
        data
    })
}
// 查询支付方式
export const getPayChannel = (data) => {
    return request({
        url: `/trader/tc/pay-channel`,
        method: 'GET',
        params:data,
    })
}

export default {
    creatOrder,
    couponOrder,
    inspectOrder,
    checkEntrust,
    checkEntrustSerial,
    underWriting,
    transactions,
    getPayChannel
}